(function($) {

  var initializeBlock = function( $block ) {
    function matchHeightFire() {
      $('.iconGrid .iconGrid-item .iconGrid-item__icon').matchHeight( {property: 'min-height'} );
      $('.iconGrid .iconGrid-item .iconGrid-item__title').matchHeight( {property: 'min-height'} );
      $('.iconGrid .iconGrid-item .iconGrid-item__text').matchHeight( {property: 'min-height'} );
    }
    matchHeightFire()

    $( window ).bind('resize orientationchange', function() {
      matchHeightFire();
    });

    setTimeout(function() {
      matchHeightFire();
    }, 1000)
  }

  $( document ).ready(function() {
    $('.block--icon-grid').each(function() {
      initializeBlock( $(this) );
    })
  })

  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=icon-grid', initializeBlock );
  }

})( jQuery );
